import axios from 'axios';
import type { Concept } from '@/models/concept';
import HttpException from './HttpException';
import type { GlobalPMSubPhase } from '@/models/pmsubphase';
import type { GlobalPMPhase } from '@/models/pmphase';

class ConceptWebservice {
    public async loadPm(isGlobal: boolean = true, includeLessons: boolean = true) {
        try {
            const response = await axios.get<GlobalPMSubPhase[]>('/concepts/pm', {
                params: {
                    is_global: isGlobal,
                    include_lessons: includeLessons,
                },
            });
            return response.data;
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the global sub_phases');
        }
    }

    public async loadPmPhasesWithLessons(title: string) {
        try {
            const response = await axios.get<GlobalPMPhase[]>('/concepts/pmPhasesWithLessons', {
                params: {
                    title,
                },
            });
            return response.data;
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the global pm phases');
        }
    }

    public updateGlobal(global: GlobalPMSubPhase) {
        return axios.post('/concepts/updateGlobal', {
            title: global.title,
        });
    }

    public async load() {
        try {
            const response = await axios.get<Concept[]>('/concepts');
            return response.data;
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the concept by a topic id');
        }
    }

    public async getById(id: number) {
        try {
            const response = await axios.get<Concept>('/concepts/getById', {
                params: {
                    id,
                },
            });

            return response.data;
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the concept by a id');
        }
    }

    public async getByTopicId(topicId: number) {
        try {
            const response = await axios.get<Concept>('/concepts/getByTopicId', {
                params: {
                    topic_id: topicId,
                },
            });

            return response.data;
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the concept by a topic id');
        }
    }

    public store(concept: Concept) {
        return axios.post<Concept>('/concepts/store', {
            ...concept,
        });
    }

    public update(concept: Concept) {
        return axios.post('/concepts/update', {
            ...concept,
        });
    }

    public remove(concept: Concept) {
        return axios.post('/concepts/remove', {
            ...concept,
        });
    }
}

export const conceptWebservice = new ConceptWebservice();
